<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('setupNews.pageTitle') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('setupNews.pageTitle'),
            href: '/admin/setup-news'
          },
          {
            text: $t('setupNews.create'),
            active: true
          }
        ]"
      />
    </div>
    <div class="row">
      <div class="col-lg-3 col-md-3 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <div class="row form-group m-b-15">
              <div class="col-md-12 text-center">
                <div id="img-frame" class="text-center">
                  <label for="feature_image" id="label_feature_image">
                    <img :src="featureImageSrc" alt="" />
                  </label>
                  <input
                    type="file"
                    id="feature_image"
                    ref="feature_image"
                    accept="image/*"
                    @change="onFileSelected"
                  />
                </div>
                <span
                  ><i>{{
                    $t('setupNews.featureImage')
                  }}</i></span
                >
              </div>
            </div>
            <div class="m-b-15">
                <label>
                  {{ $t('setupNews.titleEN') }}
                <span class="text-danger">*</span>
                </label>
                <textarea
                  rows="2"
                  v-model="model.title_en"
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('title_en') }"
                >
                </textarea>
                <div class="invalid-feedback" v-if="errors.has('title_en')">
                  {{ errors.first('title_en') }}
                </div>
            </div>
            <div class="mb-3">
                <label>
                  {{ $t('setupNews.titleKH') }}
                <span class="text-danger">*</span>
                </label>
                <textarea
                  rows="2"
                  v-model="model.title_kh"
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('title_kh') }"
                >
                </textarea>
                <div class="invalid-feedback" v-if="errors.has('title_kh')">
                  {{ errors.first('title_kh') }}
                </div>
            </div>
            <div class="mb-3">
                <label class="required">
                  {{ $t('setupNews.newsDate') }}
                </label>
                <DatePicker  
                  type="date"
                  :class="{ 'ivu-form-item-error': errors.has('news_date') }"
                  :value="model.news_date"
                  placeholder="DD-MM-YYYY"
                  format="dd-MM-yyyy"
                  @on-change="(date) => model.news_date = date"
                  style="width: 100%;"
                  ></DatePicker>
                <div class="ivu-form-item-error text-danger" v-if="errors.has('news_date')">
                  {{ errors.first('news_date') }}
                </div>
            </div>
             <div>
                <label class="required">
                  {{ $t('setupNews.categories') }}
                </label>
                  <select 
                    v-model="model.news_category_id"
                    class="form-control form-control-select"
                    :class="{ 'is-invalid': errors.has('news_category_id') }"
                    ref="news_category_id">
                    <option :value="null" disabled selected style="display: none;">
                      {{ $t('select') }}
                    </option>
                    <option v-for="(newsCategory, index) in newsCategories" :key="index" :value="newsCategory.news_category_id">
                      {{ newsCategory.category_name }}
                    </option>
                  </select>
                 <div class="invalid-feedback" v-if="errors.has('news_category_id')">
                  {{ errors.first('news_category_id') }}
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                <label class="required mt-3">
                  {{ $t('setupNews.status') }}
                </label>
                <td class="ts-whitespace-no-wrap">
                  <a-switch size="small" :checked="model.is_publish" @change="isActiveCloseOpen(model)" />
                </td>
              </div>
            </div>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-9 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <Tabs value="content_en">
              <TabPane :label="$t('setupNews.contentEN')" name="content_en">
                <VueEditor
                  v-model="model.content_en"
                  :editor-toolbar="customToolbar"
                  useCustomImageHandler
                  @imageAdded="handleImageAdded"
                />
                <div class="row">
                  <div class="col-sm-4 text-left mt-2">
                    <span v-if="errors.has('content_en')" :class="{ 'text-danger': errors.has('content_en') }">
                      {{ errors.first('content_en') }}
                    </span>
                  </div>
                </div>
              </TabPane>
              <TabPane :label="$t('setupNews.contentKH')" name="content_kh">
                <VueEditor
                  v-model="model.content_kh"
                  :editor-toolbar="customToolbar"
                  useCustomImageHandler
                  @imageAdded="handleImageAdded"
                />
                <div class="row">
                  <div class="col-sm-4 text-left mt-2">
                    <span v-if="errors.has('content_kh')" :class="{ 'text-danger': errors.has('content_kh') }">
                      {{ errors.first('content_kh') }}
                    </span>
                  </div>
                </div>
              </TabPane>
            </Tabs>
            <div class="row">
              <div class="col-sm-12 text-right mt-2">
                <ts-button
                  class="btn-primary mr-2 mt-2"
                  @click.prevent="onSaveAddNew"
                  :waiting="waitingSaveNew"
                  >{{ $t('save_add_new') }}</ts-button
                >
                <ts-button
                  class="btn-primary mt-2"
                  @click.prevent="onSave"
                  :waiting="waitingSave"
                  >{{ $t('save') }}</ts-button
                >
                <ts-button
                  class="ml-2 mt-2"
                  @click="$router.push({ name: 'setup-news' })"
                  >{{ $t('cancel') }}</ts-button
                >
              </div>
            </div>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { VueEditor } from 'vue2-editor'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'news-create',
  components: { VueEditor },
  data() {
    return {
      model: {
        title_en: '',
        title_kh: '',
        content_kh: '',
        content_en: '',
        news_category_id: null,
        is_publish:false,
        news_date: null,
      },
      waitingSave: false,
      waitingSaveNew: false,
      featureImageSrc: require('../../../assets/default-image.jpg'),
      errors: new Errors(),
      customToolbar: [
        [{ font: [] }],
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ['bold', 'italic', 'underline', 'strike'],
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' }
        ],
        [{ header: 1 }, { header: 2 }],
        ['blockquote', 'code-block'],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        [{ script: 'sub' }, { script: 'super' }],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ color: [] }, { background: [] }],
        ['link', 'image'],
        [{ direction: 'rtl' }],
        ['clean']
      ]
    }
  },
  computed: {
      ...mapState('website/setupNews', ['newsCategories']),
  },
  methods: {
      ...mapActions('website/setupNews', [
      'getNewsCategory',
    ]),
    async fetchResource() {
      this.loading = true
      await this.getNewsCategory()
      this.loading = false
    },
    isActiveCloseOpen(model) {
      model.is_publish = model.is_publish ? false : true
    },
    onFileSelected() {
      const file = this.$refs.feature_image.files[0]
      let reader = new FileReader()
      reader.addEventListener(
        'load',
        function() {
          this.featureImageSrc = reader.result
        }.bind(this),
        false
      )
      if (file) {
        if (/\.(jpe?g|png|gif)$/i.test(file.name)) {
          reader.readAsDataURL(file)
        } else {
          this.featureImageSrc = require('../../../assets/default-image.jpg')

          this.$toasted.error('invalid file type!')
          this.$refs.feature_image.value = ''
        }
      }
    },

    uploadfile() {
      this.file = this.$refs.feature_image.files[0]
        ? this.$refs.feature_image.files[0]
        : null
      if (this.file) {
        let formData = new FormData()
        formData.append('feature_image', this.file)
        return this.$store.dispatch('website/setupNews/uploadFile', formData)
      }
      return ''
    },
    
    handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      var formData = new FormData()
      formData.append('image_content', file)
      this.$store
        .dispatch('website/setupNews/newImageContent', formData)
        .then(response => {
          Editor.insertEmbed(cursorLocation, 'image', response)
          resetUploader()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    async onSave() {
      this.errors = new Errors()
      this.waitingSave = true
      let file_upload_path = await this.uploadfile()
      this.$store
        .dispatch('website/setupNews/store',Object.assign({}, this.model, { feature_image: file_upload_path }))
        .then(response => {
          this.waitingSave = false
          this.$toasted.success(response.message)
          this.$router.push({ name: 'setup-news' })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waitingSave = false
        })
    },

    async onSaveAddNew() {
      this.errors = new Errors()
      this.waitingSaveNew = true
      let file_upload_path = await this.uploadfile()
      this.$store
        .dispatch('website/setupNews/store',Object.assign({}, this.model, { feature_image: file_upload_path }))
        .then(response => {
          this.waitingSaveNew = false
          this.$toasted.success(response.message)
          this.clearFormInput()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waitingSaveNew = false
        })
    },

    clearFormInput() {
      this.model.title_en = ''
      this.model.title_kh = ''
      this.model.content_kh = ''
      this.model.content_en = ''
      this.model.is_publish = false
      this.model.news_date = ''
      this.model.news_category_id = null
      this.$refs.feature_image.value = ''
      this.featureImageSrc = require('../../../assets/default-image.jpg')
    }
  },
    beforeRouteEnter(to, from, next) {
    next(async (vm) => {
      await vm.fetchResource() 
    })
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('website/setupNews/RESET_STATE')
    }
    next()
  }
  
}
</script>
<style>
#quill-container {
  min-height: 23vh !important;
  height: 64vh !important;
  overflow-y: scroll !important;
}
</style>
<style scoped>
#feature_image {
  display: none;
}
#img-frame img {
  object-fit: contain;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 3px;
  margin: 0 auto;
}
#label_feature_image {
  cursor: pointer;
}

@import '~vue2-editor/dist/vue2-editor.css';

</style>